import { FC, ChangeEvent } from "react";
import { Box, Radio, RadioGroup } from "@mui/material";
import { RenderHTML } from "components/sanitizeHtml/sanitizeHtml";

export interface SelectionRadioOption {
  value: string;
  title: string;
  description: string;
}

export interface SelectionRadioGroupStyles {
  cardContainer: string;
  selectionCard: string;
  cardHeader: string;
  cardBody: string;
  cardDescription: string;
}

interface SelectionRadioGroupProps {
  value: string;
  options: SelectionRadioOption[];
  onChange: (value: string) => void;
  ariaLabel: string;
  styles: SelectionRadioGroupStyles;
}

export const SelectionRadioGroup: FC<SelectionRadioGroupProps> = ({
  value,
  options,
  onChange,
  ariaLabel,
  styles,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <RadioGroup
      value={value}
      onChange={handleChange}
      className={styles.cardContainer}
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const isSelected = value === option.value;
        const radioId = `selection-radio-${option.value}`;
        const labelId = `${radioId}-label`;
        const descriptionId = `${radioId}-description`;

        return (
          <Box
            component="div"
            key={option.value}
            className={styles.selectionCard}
            data-selected={isSelected ? "true" : undefined}
            onClick={() => onChange(option.value)}
          >
            <Box className={styles.cardHeader}>
              <Radio
                id={radioId}
                value={option.value}
                size="small"
                disableRipple
                slotProps={{
                  input: {
                    "aria-labelledby": labelId,
                    "aria-describedby": descriptionId,
                  },
                }}
              />
              <Box component="span" id={labelId}>
                {option.title}
              </Box>
            </Box>
            <Box className={styles.cardBody} id={descriptionId}>
              <Box className={styles.cardDescription}>
                <RenderHTML content={option.description} />
              </Box>
            </Box>
          </Box>
        );
      })}
    </RadioGroup>
  );
};
